import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Button,
    Typography,
} from '@material-tailwind/react';
import { SparklesIcon, UsersIcon, PresentationIcon } from 'lucide-react';
import { useAuth } from '../../services/contexts/authContext';

const AnnouncementModal = () => {
    const [open, setOpen] = useState(false);
    const { userDetails } = useAuth();
    
    // Primary customers do not have a teamId, team members do.
    const isTeamMember = !!userDetails?.teamId;

    useEffect(() => {
        const hasSeenModal = localStorage.getItem('hasSeenFeatureAnnouncementModal');
        if (!hasSeenModal) {
            setOpen(true);
        }
    }, []);

    const handleClose = () => {
        localStorage.setItem('hasSeenFeatureAnnouncementModal', 'true');
        setOpen(false);
    };

    return (
        <Dialog open={open} handler={handleClose} size="sm">
            <DialogHeader className="flex flex-col items-center justify-center pt-8 pb-4 text-center">
                <div className="bg-blue-50 text-blue-500 p-4 rounded-full mb-4">
                    <SparklesIcon size={32} />
                </div>
                <Typography variant="h4" color="blue-gray" className="font-bold">
                    Exciting New Features!
                </Typography>
            </DialogHeader>
            <DialogBody className="px-8 pb-8 text-blue-gray-600">
                <div className="flex items-start gap-4 mb-6">
                    <div className="bg-green-50 p-3 rounded-full shrink-0 mt-1">
                        <PresentationIcon size={20} className="text-green-500" />
                    </div>
                    <div>
                        <Typography variant="h6" color="blue-gray" className="mb-1">
                            Specific Room Quotas
                        </Typography>
                        <Typography className="text-sm mb-2">
                            We have updated how meeting room quotas work! Instead of a single global pool, your quota is now allocated specifically to individual meeting rooms.
                        </Typography>
                        <Typography className="text-sm">
                            Each room has its own sub-limits to ensure fair access and better availability across our network. You can check your specific room allowances on the Meeting Rooms page.
                        </Typography>
                    </div>
                </div>

                {!isTeamMember && (
                    <div className="flex items-start gap-4">
                        <div className="bg-purple-50 p-3 rounded-full shrink-0 mt-1">
                            <UsersIcon size={20} className="text-purple-500" />
                        </div>
                        <div>
                            <Typography variant="h6" color="blue-gray" className="mb-1">
                                Team Management
                            </Typography>
                            <Typography className="text-sm">
                                You can now manage your own team members, edit their portal access permissions, and assign individual meeting room quotas directly from the "Manage Team" tab!
                            </Typography>
                        </div>
                    </div>
                )}
            </DialogBody>
            <DialogFooter className="flex justify-center pt-0 pb-8">
                <Button variant="gradient" color="blue" onClick={handleClose} className="px-8 py-3 rounded-full border-none outline-none focus:outline-none focus:ring-0 shadow-md">
                    Got It, Thanks!
                </Button>
            </DialogFooter>
        </Dialog>
    );
};

export default AnnouncementModal;
